import { formatDate } from '@/utils/helpers';

const state = () => ({
	createdDate: new Date().toISOString().substr(0, 10),
	createdDateString: formatDate(new Date().toISOString().substr(0, 10))
});

const getters = {
};

const mutations = {
	setCreatedDate (state, createdDate) {
		state.createdDate = createdDate;
	},
	setCreatedDateString (state, createdDateString) {
		state.createdDateString = createdDateString;
	}
};

const actions = {
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
